<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <div
      class="d-flex fake-input p-0 align-items-center"
      :class="{ 'form-control': !disabled }"
    >
      <input
        disabled
        :placeholder="disabled ? '—' : placeholder"
        class="mr-1 form-control text-truncate course-alias-input"
        :value="aliasDisplay"
      />
      <AppButton
        v-if="!disabled"
        @click="modals.modify = true"
      >
        <AppIcon name="add" />
      </AppButton>
    </div>
    <FormCourseAliasModal
      v-if="modals.modify === true"
      v-bind="{ config, inline, value }"
      @update="setAlias"
      @close="modals.modify = false"
    />
  </div>
</template>

<script>
import FormMixin from './FormMixin'
import FormCourseAliasModal from './Modals/FormCourseAliasModal'
import FormLabel from './FormLabel'

export default {
  mixins: [ FormMixin ],
  components: { FormCourseAliasModal, FormLabel },
  props: {
    config: {
      type: Object,
      default: () => ({ type: 'text' }),
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return { modals: { modify: false } }
  },
  computed: {
    aliasDisplay () {
      return (this.value || []).map(alias => `${alias.subjectCode}${alias.courseNumber}`).join(',')
    },
  },
  methods: {
    setAlias (value) {
      this.$emit('input', value)
    },
  },
}
</script>
<style>
.fake-input {
  background-image: none !important;
  height: 36px;
}
.course-alias-input {
  height: 34px;
}
</style>
